export default __webpack_public_path__ + "static/media/048-warning.e8778cda.png";